"use client";

import { useEffect } from "react";

import { useArticleModalStore } from "../../store/useArticleModalStore";

const CloseModal = () => {
  const { closeModal } = useArticleModalStore();

  // Used on article pages so that the modal is closed after a refresh
  useEffect(() => {
    closeModal();
    history.replaceState(
      { ...history.state, isModalOpen: false, modalReferer: undefined },
      "",
    );
  }, []);

  return null;
};

export { CloseModal };
